import { render } from "./cpt-ninegrid.vue?vue&type=template&id=dfa37128&scoped=true"
import script from "./cpt-ninegrid.vue?vue&type=script&lang=js"
export * from "./cpt-ninegrid.vue?vue&type=script&lang=js"

import "./cpt-ninegrid.vue?vue&type=style&index=0&id=dfa37128&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfa37128"]])

export default __exports__